import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function createCategory(data) {
  return request({
    url: ENDPOINT.PLACE_CATEGORIES,
    method: 'post',
    data
  })
}

export function updateCategory(data) {
  return request({
    url: ENDPOINT.PLACE_CATEGORIES,
    method: 'patch',
    data
  })
}

export function getCategory(params) {
  return request({
    url: ENDPOINT.PLACE_CATEGORIES,
    method: 'get',
    params
  })
}

export function deleteCategory(params) {
  return request({
    url: ENDPOINT.PLACE_CATEGORIES,
    method: 'delete',
    params
  })
}

